// extracted by mini-css-extract-plugin
export default {"lineButtons":"tVM0L","betsCount":"GGx3O","singleEventButtons":"kxeTB"};